import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/profile.png'
import _imports_1 from '../assets/arsis.png'


const _hoisted_1 = {
  key: 1,
  class: "common-layout"
}
const _hoisted_2 = { class: "header-panel" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Выйти", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Войти", -1 /* HOISTED */)
const _hoisted_6 = { class: "wrap-main" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "footer-col text-end" }, [
  /*#__PURE__*/_createTextVNode(" Разработчик "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.arsis.ru",
    target: "_blank"
  }, "Арсис"),
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Arsis logo",
    src: _imports_1,
    height: "18"
  })
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.meta.hideLayout)
      ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
      : _createCommentVNode("v-if", true),
    (_ctx.$route.name && !_ctx.$route.meta.hideLayout)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_container, { direction: "vertical" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_header, {
                height: "auto",
                class: "header disable-select",
                padding: "0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_router_link, {
                      to: "/",
                      class: "decorate-off"
                    }, {
                      default: _withCtx(() => [
                        _createVNode($setup["Logo"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    (_ctx.$auth.check())
                      ? (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 0,
                          ref: "loginMenu",
                          trigger: "contextmenu",
                          placement: "bottom-end",
                          "hide-on-click": false
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                ($setup.userEmail)
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 0,
                                      class: "gap-10 item-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fas', 'envelope'],
                                          class: "main-menu-buttin-icon"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString($setup.userEmail), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                ($setup.userLocation)
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 1,
                                      class: "gap-10 item-text"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: ['fas', 'location-dot'],
                                          class: "main-menu-buttin-icon"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString($setup.userLocation), 1 /* TEXT */)
                                      ]),
                                      _: 1 /* STABLE */
                                    }))
                                  : _createCommentVNode("v-if", true),
                                _createVNode(_component_el_dropdown_item, {
                                  onClick: $setup.logout,
                                  class: "gap-10",
                                  divided: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: ['fas', 'right-from-bracket'],
                                      class: "main-menu-buttin-icon"
                                    }),
                                    _hoisted_4
                                  ]),
                                  _: 1 /* STABLE */
                                })
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "success",
                              round: "",
                              onClick: $setup.showUserMenu
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_avatar, {
                                  src: "",
                                  size: 24
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _createElementVNode("span", null, _toDisplayString($setup.userName), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            })
                          ]),
                          _: 1 /* STABLE */
                        }, 512 /* NEED_PATCH */))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "success",
                          round: "",
                          onClick: $setup.redirectLogin
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: ['fas', 'right-to-bracket'],
                              class: "main-menu-buttin-icon"
                            }),
                            _hoisted_5
                          ]),
                          _: 1 /* STABLE */
                        }))
                  ]),
                  (_ctx.$route.name && _ctx.$route.meta.hasMenu !== false)
                    ? (_openBlock(), _createBlock($setup["MenuPanel"], { key: 0 }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_main, null, {
                  default: _withCtx(() => [
                    _createCommentVNode(" <router-view /> "),
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        _createTextVNode(_toDisplayString(Component.key) + " ", 1 /* TEXT */),
                        (_ctx.$route.meta.cacheComponent)
                          ? (_openBlock(), _createBlock(_KeepAlive, { key: 0 }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                            ], 1024 /* DYNAMIC_SLOTS */))
                          : (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: 1 }))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_el_footer, { class: "primary" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_row, { align: "middle" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { sm: 8 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, "Дата обновления: " + _toDisplayString($setup.mixins.getDateTime()), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_col, { sm: 8 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, _toDisplayString(`© ${$setup.getYear()} - METRO ${$setup.appVersion}`), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_el_col, {
                          sm: 8,
                          style: {"display":"none"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_7
                          ]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}